import React, {useEffect, useState} from "react";
import neverLandUtils from "../../utils/NeverLandUtils";


const WinningBarGraph = ({data}) => {
  // 홈 원정 승률
  const [homeValue, setHomeValue] = useState(0); // 초기값 0
  const [awayValue, setAwayValue] = useState(0); // 초기값 0

  useEffect(() => {
    const homePercentage = Math.floor(Math.abs(Number(data.home?.replace('%', ''))));
    const awayPercentage = Math.floor(Math.abs(Number(data.away?.replace('%', ''))));

    setTimeout(() => {
      setHomeValue(homePercentage);
      setAwayValue(awayPercentage);
    }, 100);
  }, [data]);


  return (
      <div className="flex flex-row items-center mb-2 text-sm relative mt-6">
        {/* 홈팀 그래프 */}
        <span
            className={neverLandUtils.classNames(homeValue > awayValue ? "text-red-600" : "text-black", "w-10 text-right pr-2")}>
          {`${homeValue}%`}
        </span>
        <div className="flex-1 flex flex-row items-center">
          <div className="bg-gray-200 h-4 transition-all duration-1000 ease-in-out"
               style={{width: `${100 - homeValue}%`}}
          />
          <div
              className="bg-red-600 h-4"
              style={{width: `${homeValue}%`}}
          />
        </div>

        {/* 이름 */}
        <span className="absolute inset-0 flex justify-center items-center text-white font-bold z-10"
              style={{
                textShadow: `
                  -1px -1px 0 black,
                  1px -1px 0 black,
                  -1px 1px 0 black,
                  1px 1px 0 black
                `,
              }}
        >
          {data.name}
        </span>

        {/* 원정팀 그래프 */}
        <div className="flex-1 flex flex-row-reverse items-center">
          <div className="bg-gray-200 h-4 transition-all duration-1000 ease-in-out"
               style={{width: `${100 - awayValue}%`}}
          />
          <div
              className="bg-blue-700 h-4"
              style={{width: `${awayValue}%`}}
          />
        </div>
        <span
            className={neverLandUtils.classNames(awayValue > homeValue ? "text-red-600" : "text-black", "w-10 text-left pl-2")}>
          {`${awayValue}%`}
        </span>
      </div>
  )
}
export default WinningBarGraph;